module.exports = __webpack_public_path__ + "img/pic14.e08b272f.png";